module.exports = __webpack_public_path__ + "static/media/download_hint.1bdd8916.png";